// extracted by mini-css-extract-plugin
module.exports = {"base":"base--Rw6JeP","slots":"slots--PKnX9Q","custom":"custom--bSZaC3","slot":"slot--xSxbVj","icon":"icon--uf_nad","isActive":"isActive--AeKvcS"};